<template>
  <component-wrapper>
    <grid-container-fi
      :class="{
        'text-one-column-fi': true,
        'text-one-column-fi--centered': isCentered,
        'text-one-column-fi--dark': isDark,
      }"
    >
      <div
        :class="{
          'fi-col-start-1 fi-col-end-13 md:fi-col-start-2 md:fi-col-end-12': true,
          'lg:fi-col-start-2 lg:fi-col-end-12': isWideContent,
          'lg:fi-col-start-3 lg:fi-col-end-11': !isWideContent,
        }"
      >
        <richtext-fi
          field-name="text"
          :is-bg-dark="isDark"
        />
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script setup lang="ts">
import { RichtextFi } from 'atoms';
import { computed } from 'vue';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import { useSsrOnly } from '@/composables/ssrOnly';

defineOptions({ name: 'TextOneColumnFi' });

const props = withDefaults(
  defineProps<{
    fields?: Record<string, any>;
    markSsrOnly?: () => void;
  }>(),
  {
    fields: () => ({}),
    markSsrOnly: undefined,
  },
);

useSsrOnly(props);

const isCentered = computed(() => Boolean(props.fields?.centered?.value));
const isDark = computed(() => Boolean(props.fields?.dark?.value));
const isWideContent = computed(() => Boolean(props.fields?.wideContent?.value));
</script>

<style src="./text-one-column-fi" />
